import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./_style.scss";
import { getIconAriaData, getIconDimensions } from "helpers/icon";

const Graph = ({
  children,
  fill,
  height,
  label,
  viewBox,
  width,
  ...other
}) => {
  const aria = getIconAriaData(label);
  const dimensions = getIconDimensions(height, width);

  return (
    <svg
      className={
        classNames(
          "graph",
          other.className,
        )
      }
      fill={fill}
      height={dimensions.height}
      preserveAspectRatio="xMidYMid meet"
      viewBox={viewBox}
      width={dimensions.width}
      {...aria}
      {...other}
    >
      {children}
    </svg>
  );
};

Graph.propTypes = {
  children: PropTypes.node.isRequired,
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  target: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Graph.defaultProps = {
  fill: "currentColor",
  viewBox: "0 0 32 32",
};

export const GraphFundingNow = (props) => (
  <Graph {...props} viewBox="0 0 342 343">
    <g id="3.-Funded" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-470.000000, -869.000000)">
      <g id="Group-14" transform="translate(470.000000, 870.000000)">
        <path d="M171,0 C232.091464,0 288.544969,32.592 319.090701,85.5 C349.636433,138.408 349.636433,203.592 319.090701,256.5 C288.544969,309.408 232.091464,342 171,342 C109.908536,342 53.4550311,309.408 22.909299,256.5 C-7.63643301,203.592 -7.63643301,138.408 22.909299,85.5 C53.4550311,32.592 109.908536,0 171,0 L171,171 C171,171 171,171 171,171 C171,171 171,171 171,171 C171,171 171,171 171,171 C171,171 171,171 171,171 C171,171 171,171 171,171 C171,171 171,171 171,171 L171,0 Z" id="Base-plate" fillOpacity="0.002" fill="#455A64" />
        <g id="Segment-46">
          <path fill="#DD40AF" fillRule="evenodd" d="M171,0 C232.091464,0 288.544969,32.6112966 319.090701,85.5506217 C349.636433,138.489947 349.636433,203.71254 319.090701,256.651865 C295.23491,297.992327 255.209261,327.481776 208.67367,338 L171,171.101243 C171,171.101243 171,171.101243 171,171.101243 C171,171.101243 171,171.101243 171,171.101243 C171,171.101243 171,171.101243 171,171.101243 L171,0 Z" id="path-1" />
          <path stroke="#DD40AF" strokeWidth="0.5" d="M171.249991,0.250180589 L171.243864,171.046196 L208.862431,337.700842 C255.225111,327.150401 295.094501,297.735456 318.874161,256.526923 C349.37528,203.664919 349.37528,138.537568 318.874161,85.675564 C288.41517,32.8865713 232.156943,0.339013253 171.249991,0.250182299 Z" />
        </g>
        <path d="M209,337.790337 C149.316219,351.261842 86.9763538,331.892424 45.4585083,286.967386 C3.94066274,242.042348 -10.4394508,178.396543 7.72648453,120 L171.267976,170.82295 C171.267976,170.82295 171.267976,170.82295 171.267976,170.82295 C171.267976,170.82295 171.267976,170.82295 171.267976,170.82295 L209,337.790337 Z" id="Segment-33" fill="#1FA8DF" />
        <g id="Segment-20">
          <path fill="#BAE3F4" fillRule="evenodd" d="M7,120.228 C25.1057872,61.89 72.9067426,17.658 132.392908,4.2 C144.736947,1.41 157.350505,0 170,0 L170,171 C170,171 170,171 170,171 C170,171 170,171 170,171 L7,120.228 Z" id="path-2" />
          <path stroke="#BAE3F4" strokeWidth="0.5" d="M6.761235,120.153897 C24.8936518,61.7300948 72.7649417,17.4337626 132.337794,3.95615094 C144.704182,1.1610993 157.336326,-0.25 170,-0.25 L170.25,-0.25 L170.25,171.339718 L6.68720782,120.392417 L6.761235,120.153897 Z" />
        </g>
        <g id="Group-10" transform="translate(204.000000, 125.000000)" fill="#FFFFFF" fontFamily="SourceSansPro-Bold, Source Sans Pro, sans-serif" fontWeight="bold">
          <text id="46" fontSize="49.7664" letterSpacing="-0.651455998">
            <tspan x="0" y="49">46%</tspan>
          </text>
        </g>
      </g>
    </g>
  </Graph>
);

export const GraphFundingFuture = (props) => (
  <Graph {...props} viewBox="0 0 342 342">
    <circle id="Oval-5" fill="#DD40AF" cx="171" cy="171" r="171" />
    <g id="Group-10" transform="translate(125.000000, 135.000000)" fill="#FFFFFF" fontFamily="SourceSansPro-Bold, Source Sans Pro, sans-serif" fontWeight="bold">
      <text id="100" fontSize="49.7664" letterSpacing="-0.651455998">
        <tspan x="0" y="49">100%</tspan>
      </text>
    </g>
  </Graph>
);
